import { queryOptions, useQuery } from '@tanstack/react-query';
import { getFrickAccountBalances } from '@/services/api/frick';

export const FRICK_BALANCES_QUERY_KEY = ['treasury', 'frick', 'balances'] as const;

export const frickBalancesQueryOptions = () =>
  queryOptions({
    queryKey: FRICK_BALANCES_QUERY_KEY,
    queryFn: getFrickAccountBalances,
  });

export const useFrickBalances = () => useQuery(frickBalancesQueryOptions());
